module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "封禁注册学生"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "bannedUserForm",
    staticClass: "form",
    attrs: {
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n            " + _vm._s(item.id + ' - ' + item.nickname + ' - ' + item.ip) + "\n          ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBannedUser
    },
    on: {
      "click": _vm.bannedUser
    }
  }, [_vm._v("封禁")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e1765ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/BannedUserModal.vue
// module id = 1712
// module chunks = 8